<template>
	<div class="width-100 flex-centerize flex-column">
		<InterfaceBlocksSelectorItem
			class="pl-2 mb-3"
			:field="field"
			:key="field.id"
			v-model="localValue"
			:configurationId="configurationId"
			v-for="field in fields"
		/>
	</div>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import InterfaceBlocksSelectorItem from './InterfaceBlocksSelectorItem.vue';
export default {
	name: 'InterfaceBlocksSelector',
	mixins: [VModelMixin],
	components: {
		InterfaceBlocksSelectorItem,
	},
	props: {
		fields: { type: Array, required: true },
		configurationId: { type: Number },
	},
	computed: {},
	methods: {},
};
</script>

<style scoped lang="scss"></style>
